import { CallEmsApi, iEmsApiResponseBody } from "../../../Logic/EmsAPI/FetchExtension";

export interface QueueSummaryDTO {
    id: number;
    countByStatus: { [key: string]: number };
    countBySLA: { [key: string]: number };
}

export interface GetSummaryResponse {
    items: QueueSummaryDTO[];
}

export async function GetQueueDashboards(): Promise<iEmsApiResponseBody<GetSummaryResponse>> {
    return await CallEmsApi<GetSummaryResponse>("GET", `Mailboxes/Summary`);
}
